export default [
    {
        path: '/resourceType',
        name: 'resourceType',
        component: () => import ('./pages/Index')
    },
]